import { createContext } from 'react';
import { Company } from 'src/types';

export type InitialInsured = {
  phone?: string;
  familyName?: string;
  givenName?: string;
};

export type AddContactContextInitialData = {
  insured?: InitialInsured;
  company?: Company;
};

type AddContactContextValue = {
  isAddContactOpen: boolean;
  initialInsured: InitialInsured | undefined;
  initialCompany: Company | undefined;
  currentPageCompany: Company | undefined;
  openAddContact: ({ insured, company }?: AddContactContextInitialData) => void;
  closeAddContact: () => void;
  setCurrentPageCompany: (company: Company | undefined) => void;
};

const defaultValue = {
  isAddContactOpen: false,
} as AddContactContextValue;

export const AddContactContext = createContext(defaultValue);
